export default {
    data: () => ({
        current: {},
        status: "init",
        menu: [],
        response: {},
    }),
    async mounted(){
        this.$api.get(this.api_list)
            .then(response => {
                this.response = response;
                for(const exp of response.data){

                    // Generate submenu (excel, csv, pdf)
                    var submenu = [];
                    for(const format of ["excel", "csv", "pdf"]){
                        if (exp[format] === true) {
                            submenu.push({
                                "label": format,
                                function: async () => {
                                    this.current = {format: format, export: exp};
                                    await this.OEGDStartExport(exp.id, format, exp.is_detail);
                                }
                            });
                        }
                    }

                    // Generate main menu
                    this.menu.push({
                        label: exp.name,
                        subMenu: submenu,
                    });

                }

                this.status = "ready";
            })
            .catch(error => {
                this.status = "error";
                console.error(error);
            });
    },
    props: {
        api_list: { type: String, required: true },
        url_global: { type: String, },
        url_detail: { type: String, },
        title: { type: String, default: "Exporter" },
        icon: { type: String, default: "download" },
    },
    methods: {
        OEGDCancelCurrent(){
            this.current = {};
            this.status = "ready";
        },
        async OEGDStartExport(id, format, detail){
            this.status = "busy";
            let payload = {
                responseType: 'arraybuffer',
                params: {reporting: id, file_type: format},
            };
            this.$api.get( detail ? this.url_detail : this.url_global, payload).then(response => {
                let cd = response.headers["content-disposition"];
                let fn = cd.match("filename=(.+)")[1];
                let blob = new Blob([response.data], {});
                let link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fn;
                link.click();
                URL.revokeObjectURL(link.href);
                this.status = "ready";
            });
        },
    }
}
